import Vue from 'vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import application from './plugins/application'
import communicator from './plugins/communicator'
import VueGoogleCharts from 'vue-google-charts'
import VueI18n from 'vue-i18n'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import langs from './langs'
import './assets/label.css'
import excel from 'vue-excel-export'

import "./min.css/onlyLogo.min.css"

import "./min.css/styles.min.css"
import Particles from "particles.vue";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.config.productionTip = false
Vue.use(VueGoogleCharts)
Vue.use(excel)
Vue.use(VueI18n)
Vue.use(Particles);

import PortalVue from 'portal-vue'
Vue.use(PortalVue)
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true
})
import CountryFlag from 'vue-country-flag'

Vue.component('country-flag', CountryFlag)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDh0yvQTvP2xiVFaFEhIYLBti76uBVuRXo',
    libraries: 'places', // This is required if you use the Autocomplete plugin
  },
  // installComponents: true,
})
const i18n = new VueI18n({
  locale: 'en', // set locale
  messages: langs, // set locale messages
})

new Vue({
  router,
  store,
  i18n,
  vuetify,
  application,
  communicator,
  render: h => h('router-view')
}).$mount('#app')
